import { Box, Button, Link } from "@mui/material";
import { motion, useAnimation, AnimationControls } from "framer-motion";
import { LanguageSwitcher } from "../ui/LanguageSwitcher";

import goalngoNavLogo from "../../assets/icons/goalngo-header-logo.svg";

const hoverTextVariant = {
  rest: { y: 0, opacity: 1 },
  hover: {
    y: [-8, -24, -32, 28, 0],
    opacity: [1, 1, 0, 0, 1],
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  },
  reverse: {
    y: [0, 24, 48, -32, 0],
    opacity: [1, 0, 0, 0, 1],
    transition: {
      duration: 0.45,
      ease: "easeInOut",
    },
  },
};

export function Navbar() {
  const logoControls = useAnimation();
  const signInControls = useAnimation();
  const signUpControls = useAnimation();

  const bindHover = (controls: AnimationControls) => ({
    onHoverStart: () => void controls.start("hover"),
    onHoverEnd: () => void controls.start("reverse").then(() => controls.set("rest")),
  });
  return (
    <Box
      component="header"
      sx={{
        position: "fixed",
        top: { xs: 16, md: 24 },
        left: "50%",
        transform: "translateX(-50%)",
        mt: 0,
        width: "100%",
        maxWidth: 1200,
        borderRadius: "100px",
        boxShadow: "none",
        px: { xs: 2, md: "12px" },
        py: 1,
        zIndex: 1100,
        backgroundColor: "rgba(78, 78, 78, 0.25)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
        <motion.div {...bindHover(logoControls)} style={{ display: "inline-flex", overflow: "hidden" }}>
          <Link
            href="https://www.goalngo.com/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <motion.img
              src={goalngoNavLogo}
              alt="Goalngo"
              style={{ height: 35, width: "auto", display: "block" }}
              variants={hoverTextVariant}
              initial="rest"
              animate={logoControls}
              draggable={false}
            />
          </Link>
        </motion.div>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, overflow: "hidden" }}>
          <LanguageSwitcher />
          <motion.div {...bindHover(signInControls)} style={{ display: "inline-flex" }}>
            <Button
              sx={{
                borderRadius: "48px",
                backgroundColor: "#039103",
                color: "#fff",
                padding: "6px 16px",
                textTransform: "none",
              }}
            >
              <motion.span
                variants={hoverTextVariant}
                initial="rest"
                animate={signInControls}
                style={{ display: "inline-flex", width: "100%", justifyContent: "center" }}
              >
                Sign in
              </motion.span>
            </Button>
          </motion.div>
          <motion.div {...bindHover(signUpControls)} style={{ display: "inline-flex" }}>
            <Button
              sx={{
                borderRadius: "48px",
                backgroundColor: "#034DF2",
                color: "#fff",
                padding: "6px 16px",
                textTransform: "none",
              }}
            >
              <motion.span
                variants={hoverTextVariant}
                initial="rest"
                animate={signUpControls}
                style={{ display: "inline-flex", width: "100%", justifyContent: "center" }}
              >
                Sign up
              </motion.span>
            </Button>
          </motion.div>
        </Box>
      </Box>
    </Box>
  );
}
